import type { FC, ImgHTMLAttributes } from 'react'
import WoodworkLogo from '../Work/WoodworkLogo'
import './WoodworkPhoto.css'

type WoodworkPhotoProps = ImgHTMLAttributes<HTMLImageElement> & {
  readonly watermarkSize?: 'thumb' | 'lightbox'
  readonly layout?: 'card' | 'gallery' | 'gallery-feature' | 'lightbox'
}

const WoodworkPhoto: FC<WoodworkPhotoProps> = ({
  watermarkSize = 'thumb',
  layout = 'card',
  className = '',
  alt,
  ...imgProps
}) => {
  return (
    <span
      className={`woodwork-photo woodwork-photo--${watermarkSize} woodwork-photo--${layout} ${className}`.trim()}
    >
      <img className='woodwork-photo__img' alt={alt} {...imgProps} />
      <WoodworkLogo
        variant='leaf'
        size='accent'
        className='woodwork-photo__watermark'
        aria-hidden
      />
    </span>
  )
}

export default WoodworkPhoto
